function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M424 80H88a56.06 56.06 0 00-56 56v240a56.06 56.06 0 0056 56h336a56.06 56.06 0 0056-56V136a56.06 56.06 0 00-56-56zm-14.18 92.63l-144 112a16 16 0 01-19.64 0l-144-112a16 16 0 1119.64-25.26L256 251.73l134.18-104.36a16 16 0 0119.64 25.26z"
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0nMCAwIDUxMiA1MTInPjx0aXRsZT5pb25pY29ucy12NS1vPC90aXRsZT48cGF0aCBkPSdNNDI0LDgwSDg4YTU2LjA2LDU2LjA2LDAsMCwwLTU2LDU2VjM3NmE1Ni4wNiw1Ni4wNiwwLDAsMCw1Niw1Nkg0MjRhNTYuMDYsNTYuMDYsMCwwLDAsNTYtNTZWMTM2QTU2LjA2LDU2LjA2LDAsMCwwLDQyNCw4MFptLTE0LjE4LDkyLjYzLTE0NCwxMTJhMTYsMTYsMCwwLDEtMTkuNjQsMGwtMTQ0LTExMmExNiwxNiwwLDEsMSwxOS42NC0yNS4yNkwyNTYsMjUxLjczLDM5MC4xOCwxNDcuMzdhMTYsMTYsMCwwLDEsMTkuNjQsMjUuMjZaJy8+PC9zdmc+";
export { SvgMail as ReactComponent };